import { ChildModel, ModelBase } from 'store/model-base';

import { LineStatus, ProvisioningStatus } from 'my-account/constants';
import { BillerDevice } from './biller-device';
import { NetworkDevice } from './network-device';

export class LineDeviceCollection extends ModelBase {
    public static storeName: string = 'lineDeviceCollection';
    public static idAttribute: string = 'id.key';

    public id: Id;
    public lineId: string;  // lineId would be id.key of line, which we manually add to model
    public displayName: string;
    public lineNumber: string;
    public provisioningStatus: ProvisioningStatus;
    public status: LineStatus;
    public mismatched: boolean;
    public productId: string;
    public billerDevice: BillerDevice;
    public networkDevice: NetworkDevice;

    protected static get hasOne(): ChildModel[] {
        return [{
            attrName: 'billerDevice',
            model: BillerDevice
        }, {
            attrName: 'networkDevice',
            model: NetworkDevice
        }];
    }
}
